module.exports = __webpack_public_path__ + "media/GothamPro-Bold.a30a1d45.ttf";


//////////////////
// WEBPACK FOOTER
// ./fonts/GothamPro-Bold.ttf
// module id = 99
// module chunks = 9